export default __webpack_public_path__ + "static/media/drop-shadow-bottom.0edfd0fd.webp";